import { useEffect, useId, useRef, useState } from 'react';
import { REACTIONS, type ReactionEmoji } from '@clutch/core';

/** One quiet entry point; reactions only occupy space while the fan is choosing. */
export function ReactionPicker({ onReact }: { onReact: (emoji: ReactionEmoji) => void }) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const id = useId();
  useEffect(() => {
    if (!open) return;
    root.current?.querySelector<HTMLButtonElement>('[data-emoji]')?.focus();
    const outside = (event: PointerEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('keydown', escape);
    };
  }, [open]);
  return <div className="reaction-picker" ref={root} onBlur={(event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }}>
    <button ref={trigger} className="reaction-picker__trigger" aria-label="React to this play" aria-expanded={open} aria-controls={open ? id : undefined} onClick={() => setOpen(!open)}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" /><path d="M8 14.5c2 2.7 6 2.7 8 0" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><circle cx="9" cy="9" r="1" fill="currentColor" /><circle cx="15" cy="9" r="1" fill="currentColor" /></svg>
      <span>React</span>
    </button>
    {open && <div className="reaction-picker__panel" id={id} role="group" aria-label="Choose a reaction">
      <span>FEEL THE PLAY</span>
      <div>{REACTIONS.map((emoji) => <button data-emoji key={emoji} aria-label={`React ${emoji}`} onClick={() => {
        onReact(emoji); setOpen(false); trigger.current?.focus();
      }}>{emoji}</button>)}</div>
    </div>}
  </div>;
}
